import { render, staticRenderFns } from "./GalleryManagementView.vue?vue&type=template&id=393e28ef&"
import script from "./GalleryManagementView.vue?vue&type=script&lang=js&"
export * from "./GalleryManagementView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports